var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 57,
  height: 56,
  fill: "none",
  viewBox: "0 0 57 56"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  x: 0.5,
  fill: "#F8F9FA",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M34.438 28.691a4.95 4.95 0 0 1 2.356-4.152 5.07 5.07 0 0 0-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.987-3.608-.958a5.32 5.32 0 0 0-4.473 2.728c-1.934 3.348-.491 8.27 1.361 10.976.927 1.325 2.01 2.806 3.428 2.753 1.387-.057 1.905-.884 3.58-.884 1.658 0 2.144.884 3.59.85 1.489-.023 2.426-1.33 3.32-2.668a11 11 0 0 0 1.52-3.093 4.78 4.78 0 0 1-2.92-4.399"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M32.012 20.602a4.87 4.87 0 0 0 1.115-3.49 4.96 4.96 0 0 0-3.208 1.659 4.64 4.64 0 0 0-1.144 3.361 4.1 4.1 0 0 0 3.237-1.53"
})));
export default SvgAppStore;